import Storefront from './storefront';
import { productsByTag, productById } from './storefront/queries';

const storefront = new Storefront();

const removeActive = (colorsContainer) => {
  colorsContainer.querySelectorAll('button').forEach((swatch) => {
    const img = swatch.querySelector('img');
    if (img.classList.contains('border-black')) {
      img.classList.toggle('border-transparent');
      img.classList.toggle('border-black');
      swatch.setAttribute('aria-current', 'false');
    }
  });
};

const setToActive = (swatch) => {
  const img = swatch.querySelector('img');
  img.classList.toggle('border-transparent');
  img.classList.toggle('border-black');
  swatch.setAttribute('aria-current', 'true');
};

const swatchHandler = (colorsContainer, products, productCard) => {
  colorsContainer.querySelectorAll('button').forEach((swatch, index) => {
    const productCardImage = productCard.querySelector('.group.relative');

    if (index === 0) setToActive(swatch);

    swatch.addEventListener('click', () => {
      const img1 = productCardImage.querySelectorAll('.image')[0];
      const img2 = productCardImage.querySelectorAll('.image')[1];

      img1.src = products[index].media.edges[0].node.image.src
        ? products[index].media.edges[0].node.image.src
        : null;
      img2.src = products[index].media.edges[1].node.image.src
        ? products[index].media.edges[1].node.image.src
        : null;

      removeActive(colorsContainer);
      setToActive(swatch);
    });
  });
};

const createColors = async (productCard, counter) => {
  const productColorBlock = productCard.querySelector('.colors');
  if (!productColorBlock) return;

  const colorBlockFake = `<div class="grouped-colors min-h-[24px]">
    <div class="colors-list"></div>
  </div>`;

  productColorBlock.innerHTML = colorBlockFake;

  const dataEl = document.querySelectorAll('[data-snippet-data]');
  let data = dataEl[counter];
  if (!data) return;
  data = JSON.parse(data.textContent);
  if (data.groupTag !== null) {
    await storefront
      .request({
        query: productsByTag(data.groupTag),
      })
      .then((laterData) => {
        storefront
          .request({
            query: productById(data.product),
          })
          .then((firstData) => {
            const firstFilteredResponseJson = [firstData.data.product];
            const laterFilteredResponseJson = laterData.data.products.nodes;
            const filteredResponseJson = firstFilteredResponseJson
              .concat(laterFilteredResponseJson)
              .filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i);
            const colorBlock =
              filteredResponseJson.length > 5
                ? `<div class="grouped-colors min-h-[24px] flex flex-row">
            <div class="colors-list flex flex-row" data-size="${
              filteredResponseJson.length
            }"></div>
            <span class="animate-fade-in rounded border-1 border-grey-400 ml-[4px] px-[3px] py-[3px] text-[10px] leading-[10px] my-[3px]">+${
              filteredResponseJson.length - 5
            }</span>
          </div>`
                : `<div class="grouped-colors min-h-[24px] flex flex-row">
        <div class="colors-list flex flex-row" data-size="${filteredResponseJson.length}"></div>
      </div>`;
            const productColorBlock = productCard.querySelector('.colors');

            if (!productColorBlock) return;
            productColorBlock.innerHTML = colorBlock;

            const colorListBlock = productCard.querySelector('.colors-list');

            filteredResponseJson.slice(0, 5).forEach((color, idx) => {
              const colorHandle = color.options[1].values[0]
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/-$/, '')
                .replace(/^-/, '');
              const swatch = document.createElement('img');
              const swatchUrl = `//cdn.shopify.com/s/files/1/1011/2122/files/swatch--${colorHandle}_100x100.png`;
              if (colorHandle !== undefined) {
                const listElement = document.createElement('button');
                listElement.tabIndex = 0;
                listElement.type = 'button';
                if (idx === 0) {
                  listElement.setAttribute('aria-current', 'true');
                } else listElement.setAttribute('aria-current', 'false');
                listElement.setAttribute('aria-label', colorHandle);
                listElement.classList.add(
                  'pr-[2px]',
                  'animate-fade-in',
                  'h-[24px]',
                );
                listElement.appendChild(swatch).src = swatchUrl;
                swatch.classList.add(
                  'rounded-full',
                  'p-[3px]',
                  'border-1',
                  'border-transparent',
                  'hover:border-black',
                );
                swatch.setAttribute('loading', 'lazy');

                colorListBlock.appendChild(listElement);
              }
            });

            swatchHandler(colorListBlock, filteredResponseJson, productCard);
          });
      });
  }
};

const createSwatches = () => {
  const productCards = document.querySelectorAll(
    '.product-card, .ss__result--item',
  );
  productCards.forEach((productCard, counter) => {
    createColors(productCard, counter);
  });
};

window.createSwatches = () => createSwatches();
